import { Card, FontIcon } from "@ezmid/components-library";
import { faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { EntitySubscription } from "../../../api/users.generated";

type Props = {
  subscription?: EntitySubscription;
};

export function UserSubscriptionCard({ subscription }: Props) {
  const { t } = useTranslation();

  const formatDate = (value?: string) =>
    value ? new Date(value).toLocaleString() : "-";

  const getSubscriptionStatus = () => {
    if (subscription?.status === "ss-active") {
      return t("app.status.subscription.active");
    }

    if (subscription?.status === "ss-canceled") {
      return t("app.status.subscription.canceled");
    }

    if (subscription?.status === "ss-expired") {
      return t("app.status.subscription.expired");
    }

    return "-";
  };

  const subscriptionPlan = subscription?.subscriptionPackage?.plan
    ? subscription.subscriptionPackage.plan.replace("sp-", "").toUpperCase()
    : "-";

  const subscriptionVendor =
    subscription?.vendor === "sv-google"
      ? "Google"
      : subscription?.vendor === "sv-apple"
      ? "Apple"
      : "-";

  return (
    <Card
      shadows="lg"
      size="fill"
      hasBorder={false}
      headerText={t("app.page.subscriptions.heading")}
      headerIcon={
        <FontIcon
          marginTop={4}
          customIcon={<FontAwesomeIcon size="lg" icon={faFileInvoiceDollar} />}
        />
      }
    >
      <div className="grid grid-cols-2 gap-2 px-4 py-4 text-sm">
        <div className="text-gray-500">{t("table.header.plan")}</div>
        <div>{subscriptionPlan}</div>
        <div className="text-gray-500">{t("table.header.vendor")}</div>
        <div>{subscriptionVendor}</div>
        <div className="text-gray-500">{t("table.header.status")}</div>
        <div>{getSubscriptionStatus()}</div>
        <div className="text-gray-500">{t("table.header.startsAt")}</div>
        <div>{formatDate(subscription?.startsAt)}</div>
        <div className="text-gray-500">{t("table.header.endsAt")}</div>
        <div>{formatDate(subscription?.endsAt)}</div>
      </div>
    </Card>
  );
}
